import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../../../../Avatar'
import { EntityStatus } from '../../../../../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../../../../Icon'
import {
  getHasListingPublicationPublicUrl,
  getListingPortalLabel,
} from '../../../../../../RentalPortalListing'
import Text from '../../../../../../Text'
import { getPortalAvatarProps } from '../../../../../RentalPortal.utils'
import {
  getListingPortalDateText,
  getListingPortalStatuses,
} from '../../RentalPortalListingProfileWidgetPortals.utils'

import * as styles from './ListingProfileWidgetPortalsRowContent.module.css'

import OpenInNewWindowIcon from '../../../../../../../icons/open-in-new-window.svg'

function ListingProfileWidgetPortalsRowContent({ nameClassName, publication }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  return (
    <>
      <Avatar
        {...getPortalAvatarProps(publication.portal)}
        className={styles.logo}
        size={AVATAR_HEIGHT_24}
      />
      <span className={styles.lines}>
        <Text className={nameClassName}>
          {getListingPortalLabel(publication.portal)}
        </Text>
        <Text isSecondary className={styles.date}>
          {getListingPortalDateText({ publication, t, timezone })}
        </Text>
      </span>
      <span className={styles.trailing}>
        <EntityStatus
          id={publication.sync_status}
          statuses={getListingPortalStatuses(publication.sync_status)}
        />
        {getHasListingPublicationPublicUrl(publication) ? (
          <IconNG
            Icon={OpenInNewWindowIcon}
            color={ICON_COLOR.CurrentColor}
            size={ICON_HEIGHT_16}
          />
        ) : null}
      </span>
    </>
  )
}

export default ListingProfileWidgetPortalsRowContent
